document.addEventListener("click", e => {
  const wishlistBtn = e.target.closest(".grid-wishlist-btn");
  if (wishlistBtn) {
    const card = wishlistBtn.closest(".product-card-2__wrapper");
    const selectedSwatch = card.querySelector(".product-card-2-swatches__swatch--active");
    const productId = selectedSwatch.dataset.proid;
    const variantId = selectedSwatch.dataset.varid;
    const isAdded = wishlistBtn.dataset.added;

    if (isAdded == "false") {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.HulkappWishlist._addProductToWishlist(wishlistBtn, productId, variantId);
    }

    // setTimeout(() => window.HulkappWishlist._checkForProductStatus([wishlistBtn], "variantChange"), 2000);
  }

  const swatchesContainer = e.target.closest(".product-card-2-swatches__wrapper");
  if (swatchesContainer) {
    setTimeout(() => {
      const card = swatchesContainer.closest(".product-card-2__wrapper");
      const selectedSwatch = card.querySelector(".product-card-2-swatches__swatch--active");
      const productId = selectedSwatch.dataset.proid;
      const variantId = selectedSwatch.dataset.varid;
      const wishlistBtn = card.querySelector(".grid-wishlist-btn");
      wishlistBtn.dataset.proid = productId;
      wishlistBtn.dataset.varid = variantId;
      window.HulkappWishlist._checkForProductStatus([wishlistBtn], "variantChange");
    }, 100);
  }
});